import { CalcDistRight } from "../utils/CalcDistRight";
import { CalcDistBottom } from "../utils/CalcDistBottom";
import { DetermineBranchStyleNoChildren } from "../utils/DetermineBranchStyleNoChildren";
import { Div2Floor } from "../utils/Div2Floor";
import { DoCalculateLayout } from "../utils/DoCalculateLayout";
import {
  enumBoxHeightMode,
  enumBoxSubTypes,
  enumBoxType,
  enumBranchStyle,
  enumChartTypes,
  enumContainerType,
  enumElementLayer,
  enumHorzCentering,
  enumHorzPositioning,
  enumScalingMethod,
  enumSubChartFlag,
  enumVertCentering,
  enumVertPositioning,
  kIndentEdge,
  kManualMargins,
  kMasterSCID,
  kStandardMargins
} from "../constants";
import { GetObjectLevel } from "../utils/GetObjectLevel";
import { QBranchMgr } from "./QBranchMgr";
import { QNodeArray } from "./QNodeArray";
import { QPageNode } from "./QPageNode";
import { QPoint } from "./QPoint";
import { QRect } from "./QRect";
import { QXMLObject } from "./QXMLObject";
import { IsAssistantStyle } from "../utils/IsAssistantStyle";
import { Globals } from "./Globals";

export class QPageLayoutMgr extends QXMLObject {
  constructor() {
    super();
    /**
     * @private
     * @type {(QNodeArray | null)}
     */
    this.fActiveNodeList = null;
    this.fDoc = null;
    this.fPageWidth = null;
    this.fPageHeight = null;
    this.fLoading = false;
    this.fBranchMgr = null;
    this.fPageAuxLines = null;
    this.fChartType = enumChartTypes.standard;
    this.fIsWebView = null;
    this.fLevelChartField = null;
  }

  //=================================================================================================
  // Initialize
  InitPageLayoutMgr(
    theDoc //objDB,
  ) {
    this.fDoc = theDoc;
    this.fActiveNodeList = new QNodeArray();

    this.SetXMLElementName("pagelayoutmgr");

    var pm = theDoc.GetPageMgr();

    var canvasWidth = pm.GetMinPageWidth();
    var canvasHeight = pm.GetMinPageHeight();
    this.SetPageSize(canvasWidth, canvasHeight);

    this.fBranchMgr = new QBranchMgr();
    this.fBranchMgr.InitBranchMgr(canvasWidth);

    if (this.fIsWebView == null) {
      //TODO: The sizing mechanisms should kick in earlier - we have a weird redraw here.
      var usingPrintPreview = localStorage.printPreview === "true";
      this.SetFitToScreen(!usingPrintPreview); //default to true
    }
  }

  GetSubChartMgr() {
    var doc = this.GetDoc();
    return doc.GetSubChartMgr();
  }

  GetDoc() {
    return this.fDoc;
  }

  GetChartType() {
    return this.fChartType;
  }

  SetChartType(chartType) {
    this.fChartType = chartType;
  }

  GetLevelField() {
    return this.fLevelChartField;
  }

  SetLevelField(levelField) {
    this.fLevelChartField = levelField;
  }

  GetCurrentSubChart() {
    var scm = this.GetSubChartMgr();
    return scm.GetCurrentSubChart();
  }

  SetFitToScreen(doWebView) {
    this.fIsWebView = doWebView;
  }

  FitToScreen() {
    return this.fIsWebView;
  }

  //=================================================================================================
  // ZOrder Management
  AddToZOrder(aNode) {
    //CB 2020-01-20:  This is an infrequent operation. I'm changing it to ask for the node layout scid instead of the current one to better handle master pages.
    //Because we don't explicitly switch to SCID0 when doing MP edits.
    //var sc = this.GetCurrentSubChart();
    var scm = this.GetSubChartMgr();
    var targetscid = aNode.GetLayout().GetSubChartID();
    if (targetscid == 0) var sc = scm.GetMasterPageSubChart();
    else var sc = scm.FindSubChart(targetscid);
    if (sc) sc.AddToZOrder(aNode);
  }

  RemoveFromZOrder(aNode) {
    var sc = this.GetCurrentSubChart();
    sc.RemoveFromZOrder(aNode);
  }

  ShiftRenderOrder(nodes, mode) {
    var rootNodes = [];
    for (var i = 0; i < nodes.length; i++) {
      var aPageNode = nodes[i];
      rootNodes.push(this.GetRootNode(aPageNode));
    }
    var sc = this.GetCurrentSubChart();
    sc.ShiftRenderOrder(rootNodes, mode);
  }

  OrderRoots(roots) {
    var sc = this.GetCurrentSubChart();
    return sc.OrderRoots(roots);
  }

  AddTreeToRenderList(aNode, renderList) {
    var sourceElement = aNode.GetChartBox();
    renderList.push(sourceElement);

    var n = aNode.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var c = this.GetIndexChildNode(aNode, i);
      this.AddTreeToRenderList(c, renderList);
    }
  }

  SetRenderList(currentLayer) {
    var renderList = [];

    var sc;
    var scm = this.GetSubChartMgr();
    if (currentLayer == enumElementLayer.master)
      //enumPanelRenderMode.masterOnly
      sc = scm.GetMasterPageSubChart();
    else sc = scm.GetCurrentSubChart();

    var rootOrder = sc.GetRootOrderList();
    var n = rootOrder.length;
    for (var i = 0; i < n; i++) {
      var aNode = rootOrder[i];
      if (aNode != null) {
        var theLayout = aNode.GetLayout();
        var theLayer = theLayout.GetLayer();
        if (theLayer == currentLayer) this.AddTreeToRenderList(aNode, renderList);
      } else console.log("aNode is Null!");
    }

    return renderList;
  }

  TrimDocument() {}

  //=================================================================================================
  // Node Management
  RegisterNewNode(layout, dataObj, parentDataObj, dataObjID, theChartBox) {
    var doc = this.GetDoc();
    var newNode = new QPageNode();
    newNode.InitNode(this, layout, dataObj, dataObjID, theChartBox);
    if (dataObj != null) {
      var parent = dataObj.GetParent();
      if (parent != parentDataObj) dataObj.SetParent(parentDataObj, -1);
    }

    var subChartID = layout.GetSubChartID();
    if (subChartID == null || subChartID === kMasterSCID) {
      var scm = this.GetSubChartMgr();
      var subChartID = 0;
      if (layout.GetLayer() == enumElementLayer.content) {
        var svrTargetSCID = Globals._svrChartMgr.GetTargetSCID();
        if (svrTargetSCID != -1 && doc.IsServerChart()) {
          subChartID = svrTargetSCID;
          if (dataObj) this.FlagSubChartBreak(dataObj, layout);
        } else subChartID = scm.GetCurrentSubChartID();
      }
      layout.SetSubChartID(subChartID);

      scm.AddSCNode(layout, dataObj, dataObjID);
    }

    this.fActiveNodeList.AddNode(newNode);

    if (parentDataObj == null) this.AddToZOrder(newNode);

    layout.SetDBObj(dataObj);
    theChartBox["nodeRef"] = newNode;

    return newNode;
  }

  ReplaceActiveNodeList(newNodeList) {
    this.fActiveNodeList = newNodeList;
  }

  RemoveNode(theNode, deepRemove) {
    var index = this.fActiveNodeList.indexOf(theNode);
    if (index != -1) {
      this.RemoveFromZOrder(theNode);
      this.fActiveNodeList.splice(index, 1);

      if (deepRemove) {
        var l = theNode.GetLayout();
        var scID = l.GetSubChartID();
        var objID = theNode.GetDataObjID();
        var scm = this.GetSubChartMgr();
        scm.RemoveSCNode(objID, scID);
      }

      return true;
    }

    return false;
  }

  SetChildIndex(parentNode, childNode, newIndex) {
    var targetDataObj = childNode.GetDataObj();
    var parentDataObj = parentNode.GetDataObj();

    this.SetParent(targetDataObj, parentDataObj, newIndex);
  }

  SetParent(targetDataObj, parentDataObj, childIndex) {
    var theNode = this.FindNodeFromDataObjID(targetDataObj.GetObjectID());
    var previousParent = targetDataObj.GetParent();

    // If going from root -> not root then remove it from zOrder
    // If going from not root -> root add it to the zorder
    if (parentDataObj != null) this.RemoveFromZOrder(theNode);
    else if (previousParent != null) this.AddToZOrder(theNode);

    targetDataObj.SetParent(parentDataObj, childIndex);
  }

  GetNumNodes() {
    return this.fActiveNodeList.length;
  }

  GetIndexNode(index) {
    var node = this.fActiveNodeList[index];
    return node;
  }

  GetRootNode(aNode) {
    if (aNode == null) console.log("What the heck?");

    var dataObj = aNode.GetDataObj();
    if (dataObj === null) {
      var isContainer = aNode.GetContainerType() !== enumContainerType.nonmrb;
      if (isContainer) {
        var assocNodes = aNode.GetAssociatedNodes();
        if (assocNodes.length > 0) dataObj = assocNodes[0].GetDataObj();
        else return aNode;
      } else {
        return aNode;
      }
    }

    var parentObj = dataObj.GetParent();
    if (parentObj !== null) {
      var parentNode = this.FindNodeFromDataObjID(parentObj.GetObjectID());
      if (parentNode) {
        return this.GetRootNode(parentNode);
      } else {
        // this is the end of traversing up to the top.
        return aNode;
      }
    }
    /*
	//Problem here with top box being in a container. This fix does NOT work.
	if (aNode.GetContainerNode())
		aNode = aNode.GetContainerNode();
	*/
    return aNode;
  }

  LoadRootOrder(subChart) {
    if (subChart) sc = subChart;
    else var sc = this.GetCurrentSubChart();
    var rootOrder = sc.GetRootOrderLoad();

    if (rootOrder != null && rootOrder.length > 0) {
      sc.ClearRootOrder();
      var n = rootOrder.length;
      for (var i = 0; i < n; i++) {
        var dbObjID = rootOrder[i];
        var theNode = this.FindNodeFromDataObjID(dbObjID);
        if (theNode) this.AddToZOrder(theNode);
      }

      sc.ClearRootOrderLoad();
    } else {
      // SEPT 03 2018 - make sure there is a root page node set for a subchart
      sc.ClearRootOrder();
      var dbObjID = sc.GetTopDBObjID();
      if (dbObjID != null) {
        var theNode = this.FindNodeFromDataObjID(dbObjID);
        this.AddToZOrder(theNode);
      }
    }
  }

  FindNodeFromDataObjID(objID) {
    return this.fActiveNodeList.FindNodeFromDataObjID(objID);
  }

  FindNodeFromBox(aBox) {
    return this.fActiveNodeList.FindNodeFromBox(aBox);
  }

  FindNodeFromRecordID(person) {
    return this.fActiveNodeList.FindNodeFromRecordID(person);
  }

  GetIndexChildNode(aNode, index) {
    var dataObj = aNode.GetDataObj();
    if (dataObj == null) {
      console.log("GetIndexChildNode null dataObj");
      return null;
    }
    var childObj = dataObj.GetIndexChild(index);
    if (!childObj) {
      console.log("failed to locate child - this should not occur. Failure condition");
    }
    return this.FindNodeFromDataObjID(childObj.GetObjectID());
  }

  GetParentNode(aNode) {
    var dataObj = aNode.GetDataObj();
    if (dataObj == null) return null;

    var parentObj = dataObj.GetParent();
    var parentNode = null;

    if (parentObj != null) parentNode = this.FindNodeFromDataObjID(parentObj.GetObjectID());
    return parentNode;
  }

  FindLayoutFromDataObj(dataObj) {
    var theLayout = null;

    var theNode = this.FindNodeFromDataObjID(dataObj.GetObjectID());
    if (theNode != null) theLayout = theNode.GetLayout();
    return theLayout;
  }

  GetHolderNodes(positionNode) {
    var holderNodes = [];
    var posObj = positionNode.GetDataObj();
    var holdersList = posObj.GetHolderList();
    for (var i = 0; i < holdersList.length; i++) {
      var holderObj = holdersList[i];
      if (holderObj.IsFiltered()) continue;
      var holderNode = this.FindNodeFromDataObjID(holderObj.GetObjectID());
      if (holderNode) holderNodes.push(holderNode);
    }

    return holderNodes;
  }

  UpdateBoxLayout(curLayout, newLayout, dataObj, dataObjID) {
    var theNode = this.FindNodeFromDataObjID(dataObjID);
    if (theNode != null) {
      var scm = this.GetSubChartMgr();
      scm.UpdateLayout(curLayout, newLayout, dataObj, dataObjID);
    }

    return theNode;
  }

  GetPageMgr() {
    var d = this.GetDoc();
    return d.GetPageMgr();
  }

  SetLoading(loading) {
    this.fLoading = loading;
  }

  GetPageMarginsInt(includeHeadFoot) {
    var pm = this.GetPageMgr();
    var marginRect = pm.GetPageMarginsInt(includeHeadFoot);

    return marginRect;
  }

  DeltaToCenter(theNode, horzCentering, vertCentering, adjustpositioning) {
    var doDiag = false;

    var chartBounds = this.GetBranchBounds(theNode, false);
    var delta = new QPoint();
    var panelWidth = this.GetPageWidth();
    var chartWidth = chartBounds.fRight - chartBounds.fLeft;
    var middleChartH = chartBounds.fLeft + Math.floor(chartWidth / 2);

    var marginRect = this.GetPageMarginsInt(false); //isMasterNode
    var usableWidth = panelWidth - (marginRect.fLeft + marginRect.fRight);
    var middlePanelH = marginRect.fLeft + Math.floor(usableWidth / 2);
    var loading = this.fLoading;

    if (doDiag) {
      console.log("***");
      console.log("Panel Width is:" + panelWidth.toString());
      console.log("Chart Width is:" + chartWidth.toString());
      console.log("Chart Middle is:" + middleChartH.toString());
      console.log("Usable Panel Width is:" + usableWidth.toString());
      console.log("Middle of Panel is:" + middlePanelH.toString());
    }

    switch (horzCentering) {
      case enumHorzCentering.centermiddle:
      case enumHorzCentering.pinCenter:
        delta.fX = middlePanelH - middleChartH;
        break;
      case enumHorzCentering.pinLeft:
        //	case enumHorzCentering.stretchHorz:
        delta.fX = -chartBounds.fLeft + kIndentEdge + marginRect.fLeft;
        break;
      case enumHorzCentering.pinRight:
        delta.fX = panelWidth - chartBounds.fRight - kIndentEdge - marginRect.fRight;
        break;
      case enumHorzCentering.userplacement:
        var layout = theNode.GetLayout();
        var hP = layout.GetHorzPositioning();
        if (hP == enumHorzPositioning.stayRight && !loading && adjustpositioning) {
          var calcDistRight = CalcDistRight(layout, this);
          var distRight = layout.GetDistRight();
          if (calcDistRight != distRight) delta.fX = calcDistRight - distRight;
        }
        break;
    }

    var panelHeight = this.GetPageHeight();

    var chartHeight = chartBounds.fBottom - chartBounds.fTop;

    switch (vertCentering) {
      case enumVertCentering.centermiddle:
        var usableHeight = panelHeight - (marginRect.fTop + marginRect.fBottom);
        var middlePanelV = marginRect.fTop + Math.floor(usableHeight / 2);
        var middleChart = chartBounds.fTop + Math.floor(chartHeight / 2);
        //var middlePanelV = Math.floor(panelHeight/2);
        delta.fY = middlePanelV - middleChart;
        break;
      case enumVertCentering.centertop:
        var topChart = chartBounds.fTop;
        var r = this.GetPageMarginsInt(true); //isMasterNode
        var topMargin = r.fTop;
        var topPanel = topMargin;
        delta.fY = topPanel - topChart;
        break;
      case enumVertCentering.pinTop:
        delta.fY = -chartBounds.fTop + kIndentEdge + marginRect.fTop;
        break;
      case enumVertCentering.pinBottom:
        delta.fY = panelHeight - chartBounds.fBottom - kIndentEdge - marginRect.fBottom;
        break;
      case enumVertCentering.userplacement:
        var layout = theNode.GetLayout();
        var vP = layout.GetVertPositioning();
        if (vP == enumVertPositioning.stayBottom && !loading && adjustpositioning) {
          var calcDistBottom = CalcDistBottom(layout, this);
          var distBottom = layout.GetDistBottom();
          if (calcDistBottom != distBottom) delta.fY = calcDistBottom - distBottom;
        }
        break;
    }

    if (doDiag) {
      console.log("deltaX:" + delta.fX);
      console.log("deltaY:" + delta.fY);
    }

    return delta;
  }

  // User placed items should never be hidden off the page
  HandleUserPlacement(sizeNeededX, sizeNeededY) {
    var newBounds = this.GetTotalBounds(true, false);
    var shifterX = 0;
    var shifterY = 0;

    if (newBounds.fLeft < 0) shifterX = -newBounds.fLeft;
    else if (newBounds.fRight > sizeNeededX) shifterX = -(newBounds.fRight - sizeNeededX);

    if (newBounds.fTop < 0) shifterY = -newBounds.fTop;
    else if (newBounds.fBottom > sizeNeededY) shifterY = -(newBounds.fBottom - sizeNeededY);

    //if (shifterX != 0 || shifterY != 0)
    this.MoveAll(shifterX, shifterY, sizeNeededX, sizeNeededY, true);
  }

  ForceAspectRatio(aspectRatio) {
    this.fForceAspectRatio = aspectRatio;
  }

  // Resize the canvas as needed to accommodate new boxes or deleted boxes
  // Canvas can never be smaller than the page
  HandlePageOverflow() {
    //    console.log("Enter HandlePageOverflow");

    var p = null;
    var bounds = this.GetTotalBounds(true, false);

    var minPageWidth = this.GetMinPageWidth();
    var minPageHeight = this.GetMinPageHeight();

    if (bounds == null) {
      p = new QPoint();
      p.InitPoint(minPageWidth, minPageHeight);
      return p;
    } else if (isNaN(bounds.fBottom)) bounds = this.GetTotalBounds(true, false);

    var shiftRight = 0;
    var shiftLeft = 0;
    var shiftDown = 0;
    var shiftUp = 0;

    var needResize = false;
    //var pm = this.GetPageMgr();

    var marginRect = this.GetPageMarginsInt(true);
    var marginWidth = marginRect.fRight + marginRect.fLeft;
    var marginHeight = marginRect.fBottom + marginRect.fTop;

    // How much size do we need to accommodate the chart on the X-axis
    // If we're doing a master page alt render, then we need to respect the minimum page size and not size based on the content, since it'll be shrunk anyways
    //TODO: what is this 8?
    var sizeNeededX = bounds.fRight - bounds.fLeft + 8 + marginWidth;
    if (sizeNeededX < minPageWidth || Globals._altLayerToRender === enumElementLayer.master)
      sizeNeededX = minPageWidth;

    var curWidth = this.GetPageWidth();
    var curHeight = this.GetPageHeight();

    if (curWidth !== sizeNeededX) needResize = true;

    // Is the chart falling off the left side of the canvas
    if (bounds.fLeft < 0) shiftRight = -bounds.fLeft + 4 + marginRect.fLeft;

    // Is the chart falling off the right side of the canvas shift it left
    bounds.fRight = bounds.fRight + shiftRight;
    if (bounds.fRight > sizeNeededX)
      shiftLeft = bounds.fRight - (sizeNeededX - 4) - marginRect.fRight;

    // Repeat for the Y-axis
    var sizeNeededY = bounds.fBottom - bounds.fTop + 8 + marginHeight;
    if (sizeNeededY < minPageHeight || Globals._altLayerToRender === enumElementLayer.master)
      sizeNeededY = minPageHeight;

    if (curHeight !== sizeNeededY) needResize = true;

    if (bounds.fTop < 0) shiftDown = -bounds.fTop + 4 + marginRect.fTop;

    bounds.fBottom = bounds.fBottom + shiftDown;
    if (bounds.fBottom > sizeNeededY)
      shiftUp = bounds.fBottom - (sizeNeededY - 4) - marginRect.fBottom;

    if (shiftDown != 0 || shiftUp != 0 || shiftRight != 0 || shiftLeft != 0) needResize = true;

    var desiredAspectRatio = this.fForceAspectRatio;
    if (desiredAspectRatio && Globals._altLayerToRender == null) {
      var curRatio = sizeNeededX / sizeNeededY;
      if (curRatio > desiredAspectRatio) {
        sizeNeededY = sizeNeededX / desiredAspectRatio;
        needResize = true;
      } else if (curRatio < desiredAspectRatio) {
        sizeNeededX = sizeNeededY * desiredAspectRatio;
        needResize = true;
      }
    }

    if (needResize) {
      this.MoveAll(shiftRight - shiftLeft, shiftDown - shiftUp, sizeNeededX, sizeNeededY, false);
      this.HandleUserPlacement(sizeNeededX, sizeNeededY);

      p = new QPoint();
      p.InitPoint(sizeNeededX, sizeNeededY);
    }

    /*
    if (p!= null)
        console.log("Exit HandlePageOverflow", p.fX, " ", p.fY);
    else
        console.log("Exit HandlePageOverflow p=null");
*/

    return p;
  }

  GetObjectLevelFromNode(theNode) {
    var theObject = theNode.GetDataObj();
    if (theObject == null) return null;

    return GetObjectLevel(theObject);
    //var idDef =  theObject.GetFieldDefByID("SubChartLevel"); // this.GetIndexFieldDef(0);
    //var theLevel = theObject.GetFieldValue(idDef);

    //return theLevel;
  }

  DetermineBranchStyle(parentDataObj, defaultStyle) {
    var n = parentDataObj.GetNumChildren();
    var hasGParent = parentDataObj.GetParent();
    var bStyle = enumBranchStyle.tree;

    if (n == 0) return DetermineBranchStyleNoChildren(parentDataObj, defaultStyle); // this

    var branchStyle = null;
    var i = n - 1;
    while (branchStyle == null) {
      var childObj = parentDataObj.GetIndexChild(i--);
      var l = this.FindLayoutFromDataObj(childObj);

      // When attaching orphans there may not be a Layout associated with the data object...
      if (l == null) return DetermineBranchStyleNoChildren(parentDataObj, defaultStyle); // this
      var nodeBS = defaultStyle;
      if (nodeBS == null) nodeBS = l.GetBranchStyle();
      var isAssistant = IsAssistantStyle(nodeBS);
      if (isAssistant == null) branchStyle = nodeBS;
      else if (i < 0) {
        // Subordinates are all assistants
        branchStyle = DetermineBranchStyleNoChildren(parentDataObj, defaultStyle); // this
      }
    }

    return branchStyle;
  }

  DetermineSpacingMode(parentDataObj, addAssistant) {
    var n = parentDataObj.GetNumChildren();
    if (n == 0) {
      var l = this.FindLayoutFromDataObj(parentDataObj);
      var nodeSpacing = l.GetMarginMode();
      if (nodeSpacing == kManualMargins) nodeSpacing = kStandardMargins;
      return nodeSpacing;
    }

    var nodeSpacing = null;
    var fallback = null;
    var i = n - 1;
    while (nodeSpacing == null) {
      var childObj = parentDataObj.GetIndexChild(i--);
      var l = this.FindLayoutFromDataObj(childObj);
      var isAssist = l.IsAssistant() != null;
      var curSpacing = l.GetMarginMode();

      if (curSpacing != kManualMargins && fallback == null) fallback = curSpacing;

      if (isAssist == addAssistant && curSpacing != kManualMargins) nodeSpacing = curSpacing;
      else if (i < 0) {
        nodeSpacing = kStandardMargins;
        if (fallback != null) nodeSpacing = fallback;
      }
    }

    return nodeSpacing;
  }

  TagAutoSmartGroup(aNode) {
    this.TagAutoSmartGroupH(aNode);
    this.TagAutoSmartGroupV(aNode);
  }

  TagAutoSmartGroupH(aNode) {
    if (!aNode.IsAutoSmartH()) return;

    var rootNode1 = this.GetRootNode(aNode);
    var scl = this.GetObjectLevelFromNode(aNode);
    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var curNode = this.GetIndexNode(i);
      if (this.SameTree(rootNode1, curNode)) {
        var objLevel = this.GetObjectLevelFromNode(curNode);
        if (objLevel != null && objLevel <= scl) curNode.TagAutoSmartH();
      }
    }
  }

  TagAutoSmartGroupV(aNode) {
    if (!aNode.IsAutoSmartV()) return;

    var parentNode = this.GetParentNode(aNode);
    if (parentNode == null) return;

    var rootNode1 = this.GetRootNode(aNode);
    var n = parentNode.GetNumChildren(); // returns # of all children regardless of filter status
    for (var i = 0; i < n; i++) {
      var cNode = this.GetIndexChildNode(parentNode, i); // pageNode -> dbObj -> child dbObjs -> child node
      if (cNode == null) continue; //
      if (this.SameTree(rootNode1, cNode)) cNode.TagAutoSmartV();
    }
  }

  HandleAutoSmartV(aNode) {
    var layout = aNode.GetLayout();
    var branchStyle = layout.GetBranchStyle();

    var uniformAssistants = true;
    var assistFlag = IsAssistantStyle(branchStyle);
    var parentNode = this.GetParentNode(aNode);
    if (this.GetChartType() === enumChartTypes.card) {
      if (parentNode === null) {
        var similarSiblings = aNode.GetAllBranchNodes();
      } else {
        return;
      }
    } else {
      if (parentNode === null) {
        layout.SetSmartHeight(-1);
        return;
      }
      similarSiblings = parentNode.GetSimilarSiblingNodes(aNode);
    }

    var aList = [];
    for (var i = 0; i < similarSiblings.length; i++) {
      var childNode = similarSiblings[i];
      if (childNode === null) continue;
      var childLayout = childNode.GetLayout();
      var cvSizingMode = childLayout.GetHeightSizingMode();
      if (cvSizingMode === enumBoxHeightMode.autosmart) {
        if (this.GetChartType() === enumChartTypes.card) {
          var pushIt = true;
        } else {
          var childBranchStyle = childLayout.GetBranchStyle();
          var cAssistFlag = IsAssistantStyle(childBranchStyle);
          pushIt = assistFlag === cAssistFlag;
          if (pushIt && uniformAssistants && childBranchStyle !== branchStyle)
            uniformAssistants = false;
        }

        if (pushIt) aList.push(childNode);
      }
    }

    var maxHeight = 0;
    for (i = 0; i < aList.length; i++) {
      childLayout = aList[i].GetLayout();
      childLayout.SetSmartHeight(-1);
      childLayout.TagAutoSmartV(false);
      childLayout.PCalculateLayout(false);
      maxHeight = Math.max(maxHeight, childLayout.GetBoxHeight(false));
    }

    if (assistFlag != null && uniformAssistants) return;

    for (i = 0; i < aList.length; i++) {
      childLayout = aList[i].GetLayout();
      childLayout.SetSmartHeight(maxHeight);
      childLayout.PCalculateLayout(false);
    }
  }

  DoAutoSmartV() {
    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      var l = aNode.GetLayout();
      if (l.GetAutoSmartVTag()) this.HandleAutoSmartV(aNode);
    }
  }

  SameTree(rootNode, curNode) {
    var root2 = this.GetRootNode(curNode);
    return rootNode == root2;
  }

  HandleAutoSmartH(aNode) {
    var n = this.GetNumNodes();
    var levelWidth = new Array(100);
    var rootNode = this.GetRootNode(aNode);
    for (var i = 0; i < n; i++) {
      var curNode = this.GetIndexNode(i);
      if (curNode.IsAutoSmartH() && this.SameTree(rootNode, curNode)) {
        var l = curNode.GetLayout();
        l.SetUseCalcWidth(true);
        l.PCalculateLayout(false);
        var cWidth = l.GetBoxWidth();
        var scl = this.GetObjectLevelFromNode(curNode);
        if (scl != null) {
          var levelMax = levelWidth[scl];
          if (levelMax == null) levelMax = 0;
          if (cWidth > levelMax) levelWidth[scl] = cWidth;
        }
      }
    }

    var curMax = null;
    for (var j = 99; j > 0; j--) {
      var curLevelWidth = levelWidth[j];
      if (curLevelWidth != null) {
        if (curMax == null) curMax = curLevelWidth;
        else if (curLevelWidth > curMax) curMax = curLevelWidth;

        if (curLevelWidth < curMax) levelWidth[j] = curMax;
      }
    }

    for (var i = 0; i < n; i++) {
      var curNode = this.GetIndexNode(i);
      if (curNode.IsAutoSmartH() && this.SameTree(rootNode, curNode)) {
        var cl = curNode.GetLayout();
        var scl = this.GetObjectLevelFromNode(curNode);
        if (scl != null) {
          cl.SetBoxWidth(levelWidth[scl]);
          cl.SetUseCalcWidth(false);
          cl.TagAutoSmartH(false);
          cl.PCalculateLayout(false);
        }
      }
    }
  }

  DoAutoSmartH() {
    var lowestNode = null;
    var lowestLevel = -1;

    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      var l = aNode.GetLayout();
      if (l.GetAutoSmartHTag()) {
        var scl = this.GetObjectLevelFromNode(aNode);
        if (scl != null && lowestLevel < scl) {
          lowestLevel = scl;
          lowestNode = aNode;
        }
      }
    }

    if (lowestNode != null) this.HandleAutoSmartH(lowestNode);
  }

  CheckIsTopChainOfCommand(dbObj, curSubchart, chainLevels) {
    var curTopbox = curSubchart.GetTopDBObj();
    if (!curTopbox) {
      // No topbox found. (Crashes with blank doc workflow)
      return false;
    }

    // If chainLevels is 0, default to root (defensive handling if called when CoC off)
    if (chainLevels === 0) {
      return dbObj.IsRoot();
    }

    var parent = curTopbox;
    var levelsChecked = 0;

    // Traverse upward # chain levels
    while (parent && levelsChecked < chainLevels) {
      parent = parent.GetParent();
      levelsChecked++;
    }

    // If parent null, reached top of chart
    if (!parent) {
      // are we THE root?
      return dbObj.IsRoot();
    }

    // If we traversed all the way up chain, are we a match?
    if (levelsChecked === chainLevels && parent === dbObj) {
      return true;
    }

    // Not top
    return false;
  }

  NodeTopOfSubChart(theNode, chartOnly) {
    var scm = this.GetSubChartMgr();
    var objId = theNode.GetDataObjID();
    var topOfSC = scm.IsTopOfSubChart(objId);
    var chainLevels = this.fDoc.GetRequestedChainLevels();
    const isVacantBox = theNode?.GetChartBox?.().IsVacantBox?.();

    if (topOfSC && chainLevels == 0) return true;
    var dbObj = theNode.GetDataObj();
    if (dbObj == null) {
      if (isVacantBox) return false;
      var containerType = theNode.GetContainerType();
      if (containerType == enumContainerType.nonmrb) return !chartOnly;
      else {
        return false;
      }
    }

    var docRef = this.GetDoc();
    if (dbObj.IsHolderObj() && docRef.IsPositionDocument()) return false;

    var isRoot = false;
    if (chainLevels == 0)
      // Chain of Command is not enabled
      isRoot = dbObj.IsRoot();
    else isRoot = this.CheckIsTopChainOfCommand(dbObj, scm.GetCurrentSubChart(), chainLevels);

    return isRoot;
  }

  GetRootNodes(selectedNodes, chartOnly) {
    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      if (this.NodeTopOfSubChart(aNode, chartOnly))
        //IsRootNode
        selectedNodes.push(aNode);
    }
  }

  GetRootNodeForSubChart() {
    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      if (aNode == true || aNode == false) break;
      if (aNode.GetDataObj() && this.NodeTopOfSubChart(aNode, true))
        //IsRootNode
        return aNode;
    }
  }

  RecalculatePageLayout(pageNode) {
    if (pageNode != null) {
      this.DoAutoSmartH();
      this.DoAutoSmartV();

      var rootNode = this.GetRootNode(pageNode);

      // if root node is container, we need to get to one of the inside associates.
      // this is not the case for positions... the container itself will contain references to its children
      if (
        rootNode.GetContainerType() === enumContainerType.standardmrb &&
        rootNode.GetAssociatedNodes().length > 0 &&
        !rootNode.IsPositionsNode()
      ) {
        rootNode = rootNode.GetAssociatedNodes()[0];
      }

      var oldX = rootNode.GetPositionX();
      var oldY = rootNode.GetPositionY();

      this.InitPageAuxLineList();
      DoCalculateLayout(this.fBranchMgr, rootNode, this.fPageAuxLines, this.GetChartType());

      var newX = rootNode.GetPositionX();
      var newY = rootNode.GetPositionY();
      var deltaX = oldX - newX;
      var deltaY = oldY - newY;
      this.MoveChart(rootNode, deltaX, deltaY);
    }

    var newCanvasSize = this.HandlePageOverflow();
    return newCanvasSize;
  }

  //----------------------------------
  InitPageAuxLineList() {
    if (this.fPageAuxLines === null) {
      this.fPageAuxLines = [];
    }
  }

  GetAuxLineList() {
    return this.fPageAuxLines;
  }

  //------------------------------------
  GetChartNodes(aNode, includeContainers) {
    var allNodes = [];
    var rootNodes = [];
    // let's first find root node of aNode.
    var rootNode = this.GetRootNode(aNode);

    // if this root node has co-head associates, get them and traverse through all their branches
    var rootContainerNode = rootNode.GetContainerNode();
    if (rootContainerNode) {
      var associateNodes = rootContainerNode.GetAssociatedNodes();
      rootNodes = associateNodes.slice();
    } else {
      rootNodes.push(rootNode);
    }

    for (var i = 0; i < rootNodes.length; i++) {
      allNodes.push(rootNodes[i]);
      var childNodes = this.GetAllChildrenNodes(rootNodes[i]);
      for (var j = 0; j < childNodes.length; j++) {
        allNodes.push(childNodes[j]);
      }
    }

    if (includeContainers) {
      var seen = new Set(allNodes);
      var numNodes = allNodes.length;
      for (i = 0; i < numNodes; i++) {
        var containerNode = allNodes[i].GetContainerNode();
        if (containerNode && !seen.has(containerNode)) {
          allNodes.push(containerNode);
          seen.add(containerNode);
        }
      }
    }

    return allNodes;
  }

  // gets all the children nodes of aNode plus children of children, etc.
  GetAllChildrenNodes(aNode) {
    var result = [];
    var stack = [];
    // Seed with aNode's children in reverse for correct DFS preorder
    var numRoot = aNode.GetNumChildren();
    for (var i = numRoot - 1; i >= 0; i--) {
      var c = this.GetIndexChildNode(aNode, i);
      if (c) stack.push(c);
    }
    while (stack.length > 0) {
      var node = stack.pop();
      result.push(node);
      var numChildren = node.GetNumChildren();
      for (var i = numChildren - 1; i >= 0; i--) {
        var childNode = this.GetIndexChildNode(node, i);
        if (childNode) stack.push(childNode);
      }
    }
    return result;
  }

  // returns the bounds of a branch that startNode is included.
  GetBranchBounds(startNode, includeShadow, boxesOnly) {
    if (typeof boxesOnly === "undefined") {
      boxesOnly = false;
    }

    var bounds = new QRect();
    bounds.SetInfiniteRect();

    var allNodes = this.GetChartNodes(startNode, true);

    for (var i = 0; i < allNodes.length; i++) {
      var aNode = allNodes[i];
      var borderThickness = aNode.GetLayout().GetBorderOutset();
      if (aNode.fNodeEntity) {
        var nodeBoundary = aNode.fNodeEntity.GetBoundary(
          includeShadow,
          boxesOnly,
          this.GetChartType(),
          allNodes.length
        );
      } else {
        nodeBoundary = {
          left: aNode.GetPositionX(),
          right: aNode.GetPositionX() + aNode.GetBoxWidth() + 2 * borderThickness,
          top: aNode.GetPositionY(),
          bottom: aNode.GetPositionY() + aNode.GetBoxHeight() + 2 * borderThickness
        };
      }

      bounds.fTop = Math.min(bounds.fTop, nodeBoundary.top);
      bounds.fBottom = Math.max(bounds.fBottom, nodeBoundary.bottom);
      bounds.fLeft = Math.min(bounds.fLeft, nodeBoundary.left);
      bounds.fRight = Math.max(bounds.fRight, nodeBoundary.right);
    }

    return bounds;
  }

  // This includes the shadow
  GetTotalBounds(onlyChart, boxesOnly) {
    var totalBounds = new QRect();
    totalBounds.SetInfiniteRect();
    var skipMasterNodes =
      Globals._altLayerToRender != null && Globals._altLayerToRender !== enumElementLayer.master;
    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      if (skipMasterNodes && aNode.GetMasterNode()) continue;
      var isTopOfSubChart = this.NodeTopOfSubChart(aNode, false);

      if (isTopOfSubChart) {
        var layout = aNode.GetLayout();
        var boxType = layout.GetBoxType();
        var boxSubType = layout.GetBoxSubType();
        var isStandardBox = boxType === enumBoxType.standard;
        var isContainerBox =
          boxType === enumBoxType.nonstandard && [enumBoxSubTypes.refMRBox].includes(boxSubType);
        var proceed = !onlyChart || isStandardBox || isContainerBox;
        if (proceed) {
          var bounds = this.GetBranchBounds(aNode, true, boxesOnly);
          totalBounds.UnionRect(bounds);
        }
      }
    }
    return totalBounds;
  }

  AutoCenterChart(aNode) {
    if (aNode == null) return;

    var rootNode = this.GetRootNode(aNode);

    var l = rootNode.GetLayout();
    var hC = l.GetChartHorzCentering();
    var vC = l.GetChartVertCentering();
    var delta = this.DeltaToCenter(rootNode, hC, vC, false);
    if (delta.fX != 0 || delta.fY != 0) this.MoveChart(rootNode, delta.fX, delta.fY);
  }

  AutoCenterAll() {
    //console.log("AutoCenterAll");

    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      if (this.NodeTopOfSubChart(aNode, false)) {
        var l = aNode.GetLayout();
        var hC = l.GetChartHorzCentering();
        var vC = l.GetChartVertCentering();
        var delta = this.DeltaToCenter(aNode, hC, vC, true);
        if (delta.fX != 0 || delta.fY != 0) this.MoveChart(aNode, delta.fX, delta.fY);

        this.AutoStretchNode(aNode);
      }
    }
  }

  CalculateScale(scaleW, scaleH, scalingMethod, boxLayout) {
    var p = new QPoint();
    p.InitPoint(scaleW, scaleH);
    var sizeH = false;
    var sizeW = false;
    var boxsize, marginRect;
    var gutterX, gutterY;
    var picWidth, picHeight;

    switch (scalingMethod) {
      case enumScalingMethod.lockaspect:
      case enumScalingMethod.unlockaspect:
        break;
      case enumScalingMethod.scalehorz:
        //p.fY = 100;
        sizeW = true;
        break;
      case enumScalingMethod.scalevert:
        //p.fX = 100;
        sizeH = true;
        break;
      case enumScalingMethod.scaletopage:
        sizeW = true;
        sizeH = true;
        break;
    }

    if (sizeW || sizeH) {
      picWidth = boxLayout.GetBoxWidth();
      picHeight = boxLayout.GetBoxHeight(false);

      var l = boxLayout;
      var c1 = l.GetCellDesc(1, 1);
      picWidth = c1.GetSPictureWidth();
      picHeight = c1.GetSPictureHeight();

      var borderOutset = l.GetBorderOutset();

      //var c0H = l.GetCellDesc(0,1);
      //var c2H = l.GetCellDesc(2,1);
      //var c0V = l.GetCellDesc(1,0);
      //var c2V = l.GetCellDesc(1,2);
      //gutterX = c0H.GetCellWidth() + c2H.GetCellWidth() + kIndentEdge*2;
      //gutterY = c0V.GetCellHeight() + c2V.GetCellHeight() + kIndentEdge*2;
      gutterX = kIndentEdge * 2 + borderOutset * 2;
      gutterY = kIndentEdge * 2 + borderOutset * 2;

      marginRect = this.GetPageMarginsInt(false);

      var ignoreMargin = false;

      // SD11302018
      if (ignoreMargin) {
        marginRect = new QRect();
        marginRect.InitRect(0, 0, 0, 0);
      }

      var curHC = boxLayout.GetChartHorzCentering();
      if (curHC == enumHorzCentering.userplacement) {
        boxLayout.SetChartHorzCentering(enumHorzCentering.pinLeft);
      }

      var curVC = boxLayout.GetChartVertCentering();
      if (curVC == enumVertCentering.userplacement) {
        boxLayout.SetChartVertCentering(enumVertCentering.pinTop);
      }

      // SD11302018
      if (ignoreMargin) {
        boxLayout.SetChartVertCentering(enumVertCentering.userplacement);
        boxLayout.SetChartHorzCentering(enumHorzCentering.userplacement);
        boxLayout.SetPosition(Div2Floor(gutterX), Div2Floor(gutterY));
      }
    }

    if (sizeW) {
      var panelWidth = this.GetPageWidth();
      var usableWidth = panelWidth - (marginRect.fLeft + marginRect.fRight) - gutterX;
      p.fX = (usableWidth / picWidth) * 100;
    }

    if (sizeH) {
      var panelHeight = this.GetPageHeight();
      var usableHeight = panelHeight - (marginRect.fTop + marginRect.fBottom) - gutterY;
      p.fY = (usableHeight / picHeight) * 100;
    }

    return p;
  }

  AutoStretchNode(aNode) {
    var cb = aNode.GetChartBox();
    if (!cb.IsStaticPicture()) return;
    var scaleW = cb.GetSPictureScaleW();
    var scaleH = cb.GetSPictureScaleH();
    var scalingMethod = cb.GetScalingMethod();
    cb.SetSPictureScale(scaleW, scaleH, scalingMethod);
  }

  AutoStretch(nodeList) {
    if (nodeList == null) return;

    var n = nodeList.length;
    for (var i = 0; i < n; i++) {
      var aNode = nodeList[i];
      this.AutoStretchNode(aNode);
    }
  }

  //=================================================================================================
  // Movement on the page
  MoveAll(deltaX, deltaY, sizeNeededX, sizeNeededY, forceMove) {
    var noMove = deltaX == 0 && deltaY == 0;
    if (!forceMove && noMove) return;

    var n = this.GetNumNodes();
    for (var i = 0; i < n; i++) {
      var aNode = this.GetIndexNode(i);
      var theLayout = aNode.GetLayout();
      var hC = theLayout.GetChartHorzCentering();
      var vC = theLayout.GetChartVertCentering();
      var userPosX = hC == enumHorzCentering.userplacement;
      var userPosY = vC == enumVertCentering.userplacement;
      var boxType = theLayout.GetBoxType();

      var theLayer = theLayout.GetLayer();
      if (!noMove && theLayer == enumElementLayer.content) {
        if (boxType == enumBoxType.standard && this.NodeTopOfSubChart(aNode, false)) {
          var dX = deltaX;
          var dY = deltaY;
          if (!forceMove) {
            if (userPosX) dX = 0;
            if (userPosY) dY = 0;
          }
          this.MoveChart(aNode, dX, dY);
        }
      }
    }
  }

  SetUserCentering(startNode) {
    var rootNode = this.GetRootNode(startNode);
    var l = rootNode.GetLayout();
    l.SetChartHorzCentering(enumHorzCentering.userplacement);
    l.SetChartVertCentering(enumVertCentering.userplacement);
  }

  MoveChart(startNode, deltaX, deltaY) {
    var myContainerNode = startNode.GetContainerNode();
    if (startNode.GetContainerType() == enumContainerType.standardmrb) myContainerNode = startNode;
    if (myContainerNode !== null) {
      // start node is part of a container. its container and associated nodes need to move
      this.DoMoveBranch(myContainerNode, deltaX, deltaY);
      if (!myContainerNode.IsPositionsNode()) {
        var associatedNodes = myContainerNode.GetAssociatedNodes();
        for (var i = 0; i < associatedNodes.length; i++) {
          var aNode = associatedNodes[i];
          this.DoMoveBranch(aNode, deltaX, deltaY);
        }
      }
    } else {
      this.DoMoveBranch(startNode, deltaX, deltaY);
    }
  }

  DoMoveBranch(parentNode, deltaX, deltaY) {
    //console.log("DoMoveBranch:", deltaX," ", deltaY);

    this.MoveNode(parentNode, deltaX, deltaY);
    var n = parentNode.GetNumChildren();
    var childNode;

    var containers = [];
    if (parentNode.GetContainerType() == enumContainerType.standardmrb) containers.push(parentNode);
    for (var i = 0; i < n; i++) {
      childNode = this.GetIndexChildNode(parentNode, i);
      if (!childNode) continue;
      this.DoMoveBranch(childNode, deltaX, deltaY);
      var containerNode = childNode.GetContainerNode();
      if (containerNode && containers.indexOf(containerNode) === -1) {
        this.DoMoveBranch(containerNode, deltaX, deltaY);
        containers.push(containerNode);
      }
    }
    if (parentNode.IsPositionsNode()) {
      var associatedNodes = parentNode.GetAssociatedNodes();
      for (var i = 0; i < associatedNodes.length; i++) {
        var aNode = associatedNodes[i];
        this.DoMoveBranch(aNode, deltaX, deltaY);
      }
    }
  }

  ResetEdgeDistance(aNode) {
    if (this.fLoading) return;

    var l = aNode.GetLayout();
    var distRight = CalcDistRight(l, this);
    var distBottom = CalcDistBottom(l, this);
    l.SetDistRight(distRight);
    l.SetDistBottom(distBottom);
  }

  MoveNode(aNode, deltaX, deltaY) {
    var xPos = aNode.GetPositionX();
    var yPos = aNode.GetPositionY();
    //console.log("MoveNode:", aNode.GetID(), ":", deltaX,",", deltaY, "  ", xPos, ",", yPos, " --> ", xPos + deltaX, ",", yPos + deltaY);
    xPos = xPos + deltaX;
    yPos = yPos + deltaY;
    aNode.SetPosition(xPos, yPos);

    var nodeID = aNode.GetID();
    //	console.log("MoveNode",nodeID);
    var p = aNode.GetColumnPositions();
    if (p != null) aNode.SetColumnPositions(p.fX + deltaX, p.fY + deltaX);
  }

  //=================================================================================================
  // Load & Save
  OutputToJSON(stream) {
    var plmObj = {};

    var chartType = this.GetChartType();
    plmObj["chartType"] = chartType;

    var levelField = this.GetLevelField();
    if (levelField) plmObj["levelField"] = levelField;

    return plmObj;
  }

  OutputSubElements(stream) {
    var chartType = this.GetChartType();
    this.OutputSimpleElement("charttype", chartType, stream);

    var levelName = this.GetLevelField();
    if (levelName) this.OutputSimpleElement("levelfield", levelName, stream);
  }

  LoadFromJSON(json) {
    this.SetChartType(json["chartType"]);
    this.SetLevelField(json["levelField"]);
  }

  LoadSubElements(objTree) {
    var chartType = objTree.GetValueForChild("charttype", true);
    this.SetChartType(chartType);

    var levelName = objTree.GetValueForChild("levelfield", false);
    if (levelName) this.SetLevelField(levelName);
  }

  //==============================================================================
  // Subchart Management
  InsertSubChartBreak(theNode) {
    var targetLayout = theNode.GetLayout();
    var dataObj = theNode.GetRootDataObj();
    var dataObjID = dataObj.GetObjectID();

    var scm = this.GetSubChartMgr();
    var newSubChart = scm.InsertSubChartBreak(targetLayout, dataObj, dataObjID, true);

    if (theNode.GetContainerNode()) theNode = theNode.GetContainerNode();
    targetLayout = theNode.GetLayout();
    if (targetLayout.GetAssociatedObjIDs()) {
      if (theNode.fDataObj && theNode.fDataObj.IsPositionObj()) {
        return;
      }

      //You miss every shot you don't take.
      scm.UpdateMRBBreaks(
        theNode.GetChartBox(),
        theNode.GetAssociatedNodes().map(function (a) {
          return a.GetChartBox();
        })
      );
    }
  }

  RemoveSubChartBreak(theNode, okToOptimizePage, avoidEmployeeNodes = false) {
    var targetLayout = theNode.GetLayout();
    var dataObj = theNode.GetDataObj();
    var dataObjID = theNode.GetDataObjID();
    var scm = this.GetSubChartMgr();

    if (theNode.GetContainerNode()) {
      var containerPLMNode = theNode.GetContainerNode();
      var containerObjID = containerPLMNode.fDataObjID;
      var curSCID = targetLayout.GetSubChartID();
      var associatedIDs = containerPLMNode.GetAssociatedNodes().map(function (a) {
        return a.fDataObjID;
      });
      for (var anID = 0; anID < associatedIDs.length; anID++) {
        var boxDataObjID = associatedIDs[anID];
        if (dataObjID == boxDataObjID) continue;
        var index = scm.FindSCSubNodeIndex(boxDataObjID, curSCID);
        var childSCNode = scm.GetIndexSCNode(index);
        var curBox = this.FindNodeFromDataObjID(boxDataObjID).fChartBox;
        curBox.SetSubChartFlag(enumSubChartFlag.nobreak);
        var childSCID = childSCNode.GetSubChartID();
        scm.RemoveSCNode(boxDataObjID, childSCID);
        scm.UpdateSubChartID(childSCNode, childSCID, curSCID);
      }
      scm.RemoveSCNode(containerObjID, childSCID);
      containerPLMNode.GetLayout().SetSubChartFlag(enumSubChartFlag.nobreak);
    }
    scm.RemoveSubChartBreak(targetLayout, dataObj, dataObjID, okToOptimizePage, avoidEmployeeNodes);
  }

  HasSubordinateSubChart(theNode) {
    var l = theNode.GetLayout();
    var scFlag = l.GetSubChartFlag();
    if (scFlag == enumSubChartFlag.drilldown) return true;

    var n = theNode.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var childNode = this.GetIndexChildNode(theNode, i);
      var hasSubSC = this.HasSubordinateSubChart(childNode);
      if (hasSubSC) return true;
    }
    return false;
  }

  // Import Performance
  EnableIndexing(enableIndexing) {
    return this.fActiveNodeList.SetIsIndexed(enableIndexing);
  }

  CopyPLMSettings(iWiz) {
    //NOTE - this may not play well with multi-chart documents
    var priorDocMgr = iWiz.GetPriorDocMgr();
    if (priorDocMgr == null) return null;
    var priorDoc = priorDocMgr.GetIndexDoc(0);
    if (priorDoc == null) return;

    var priorPLM = priorDoc.GetPageLayoutMgr();
    var chartType = priorPLM.GetChartType();
    //Note - don't try to 'simplify' the null checks here. 0 evaluates to false.
    if (chartType != null) this.SetChartType(chartType);
    var levelField = priorPLM.GetLevelField();
    if (levelField != null) this.SetLevelField(levelField);
  }

  SetPageSize(pageWidth, pageHeight) {
    //    this.fPriorPageWidth = this.GetPageWidth();
    //    this.fPriorPageHeight = this.GetPageHeight();

    this.fPageWidth = pageWidth;
    this.fPageHeight = pageHeight;
  }

  GetPageWidth() {
    return this.fPageWidth;
  }

  GetPageHeight() {
    return this.fPageHeight;
  }

  GetMinPageWidth() {
    var theDoc = this.GetDoc();
    var pm = theDoc.GetPageMgr();
    var minWidth = pm.GetMinPageWidth();
    return minWidth;
  }

  GetMinPageHeight() {
    var theDoc = this.GetDoc();
    var pm = theDoc.GetPageMgr();
    var minHeight = pm.GetMinPageHeight();
    return minHeight;
  }

  GetPageProps() {
    var theDoc = this.GetDoc();
    var pm = theDoc.GetPageMgr();
    var pageProps = pm.GetPageProps();
    return pageProps;
  }

  //=================================================================================================
  FlagSubChartBreak(dataObj, layout) {
    var fieldDef = dataObj.GetFieldDefByID("scFlag");
    if (fieldDef == null) {
      layout.SetSubChartFlag(enumSubChartFlag.nobreak);
      return;
    }
    var scFlag = dataObj.GetFieldValue(fieldDef);

    if (scFlag == "Up") layout.SetSubChartFlag(enumSubChartFlag.drillup);
    else if (scFlag == "Down") layout.SetSubChartFlag(enumSubChartFlag.drilldown);
  }
}
